var React = require('react');

function IconDashPipeline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M604.5 471.3H665c11.9-46.4 54-80.6 104.1-80.6 59.4 0 107.5 48.1 107.5 107.5s-48.1 107.5-107.5 107.5c-50.1 0-92.2-34.2-104.1-80.6h-60.5c-11.9 46.4-54 80.6-104.1 80.6s-92.2-34.2-104.1-80.6h-59.9c-11.9 46.4-54 80.6-104.1 80.6-59.4 0-107.5-48.1-107.5-107.5s48.1-107.5 107.5-107.5c50.1 0 92.2 34.2 104.1 80.6h59.9c11.9-46.4 54-80.6 104.1-80.6s92.2 34.3 104.1 80.6zm-372 80.6c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8-53.8 24.1-53.8 53.8 24.1 53.8 53.8 53.8zm536.6 0c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8c-29.7 0-53.8 24.1-53.8 53.8s24.1 53.8 53.8 53.8zm-268.6 0c29.7 0 53.8-24.1 53.8-53.8s-24.1-53.8-53.8-53.8-53.8 24.1-53.8 53.8 24.1 53.8 53.8 53.8z"}));
}

IconDashPipeline.displayName = "IconDashPipeline";

IconDashPipeline.defaultProps = {"viewBox":"0 0 1000.6 1000.7"};

module.exports = IconDashPipeline;

IconDashPipeline.default = IconDashPipeline;
